import dataConvertService from '@/service/dataConvert.service'

import { DTO } from '../DTO'
import type { CurriculumTreeNode } from './CurriculumTreeNode'

export class CurriculumTreeByChapter<T extends res.Curriculum = res.Curriculum> extends DTO {
  curriculumTreeNode: CurriculumTreeNode[]
  curriculumTreeMap: Map<string, res.Curriculum>

  constructor(data: T[]) {
    super()

    const { treeNode, dataMap } = dataConvertService.curriculumToTreeData(data)

    this.curriculumTreeNode = treeNode
    this.curriculumTreeMap = dataMap
  }
}
